import React, { useState } from 'react';
import { useSelectedComentarioId } from '../../graphql/hooks/hooks';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
// @material-ui/icons
import Close from '@material-ui/icons/Close';
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import Button from '../UI/CustomButtons/Button';
import CustomInput from '../UI/CustomInput/CustomInput';
// Validations
import { isEmpty } from '../../util/validators';

import sectionDelStyle from '../../assets/jss/coscef/views/articuloSections/sectionDelStyle';

const useStyles = makeStyles(sectionDelStyle);
function Transition(props) {
  return <Slide direction='down' {...props} />;
}
const ArticuloRes = (props) => {
  const classes = useStyles();
  const selectedComentarioId = useSelectedComentarioId();
  const [formRespuesta, setFormRespuesta] = useState('');
  const [addForm, setAddForm] = useState({
    respuesta: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
  });
  const [formIsValid, setFormIsValid] = useState(false);

  const inputChangedHandler = (value, input) => {
    let isValid = true;

    for (let validator of addForm[input].validators) {
      isValid = isValid && validator(value);

      if (input === 'respuesta') {
        if (isValid) setFormRespuesta('success');
        else setFormRespuesta('error');
      }
    }

    const updatedForm = {
      ...addForm,
      [input]: {
        ...addForm[input],
        valid: isValid,
        value: value,
      },
    };

    let formIsValid = true;
    for (const inputName in updatedForm) {
      formIsValid = formIsValid && updatedForm[inputName].valid;
    }

    setAddForm(updatedForm);
    setFormIsValid(formIsValid);
  };

  const respuestaHandler = (event) => {
    event.preventDefault();

    const respuestaData = {};
    for (let i in addForm) {
      respuestaData[i] = addForm[i].value;
    }

    //console.log(respuestaData);

    props.respuestaComentario(selectedComentarioId, respuestaData);
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={6} md={6} lg={4}>
        <Dialog
          classes={{
            root: classes.modalRoot,
            paper: classes.modal,
          }}
          open={props.show}
          TransitionComponent={Transition}
          keepMounted
          onClose={props.close}
          aria-labelledby='classic-modal-slide-title'
          aria-describedby='classic-modal-slide-description'
        >
          <DialogTitle
            id='classic-modal-slide-title'
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              simple
              className={classes.modalCloseButton}
              key='close'
              aria-label='Close'
              onClick={props.close}
            >
              {' '}
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle}>Responder Comentario</h4>
          </DialogTitle>
          <form onSubmit={respuestaHandler}>
            <DialogContent
              id='classic-modal-slide-description'
              className={classes.modalBody}
            >
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText='Respuesta '
                    id='message'
                    success={formRespuesta === 'success'}
                    error={formRespuesta === 'error'}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.textArea,
                    }}
                    inputProps={{
                      multiline: true,
                      rows: 5,
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'respuesta');
                      },
                    }}
                  />
                </GridItem>
              </GridContainer>
            </DialogContent>
            <DialogActions className={classes.modalFooter}>
              <Button color='youtube' onClick={props.close}>
                Cancelar
              </Button>{' '}
              <Button type='submit' color='success' disabled={!formIsValid}>
                Enviar
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </GridItem>
    </GridContainer>
  );
};

export default ArticuloRes;
